











import { ShaqFAQ } from '@/models/Objects';
import { State } from 'vuex-class';
import { StoreState } from '@/store/states';
import FAQService from '@/services/FAQService';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ShaqFAQComponent extends Vue {
  @State((state: StoreState) => state.currentFAQ)
  shaqFAQ?: ShaqFAQ;


  created (): void {
    FAQService.getInstance(this.$store);
  }
}
